import ResponsiveAppBar from "../../../layouts/navbar";

import { ProductTypes } from "./components/productTypes";
import { Categories } from "./components/Categories";
import { CustomizeBanner } from "./components/FeaturedProducts";
import { LatestProducts } from "./components/LatestProduct";
import { Testimonials } from "./components/Testimonials";
import { Collaboration } from "./components/Collaboration";
import { Service } from "./components/Service";
import { Banner } from "./components/Banner";
import { Footer } from "../../../layouts/footer";
import { SpecialProducts } from "./components/SpecialProducts";
import { useEffect } from "react";

export const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    localStorage.removeItem("order_uuid");
    localStorage.removeItem("product_id");
    localStorage.removeItem("orderDetails");
    localStorage.removeItem("offer_id");
  }, []);
  return (
    <>
      <div id="wrapper">
        <ResponsiveAppBar />

        <ProductTypes />
        <Banner />
        <SpecialProducts />
        {/* <Categories /> */}
        {/* commented on 12/02  */}
        <CustomizeBanner />
        {/* <LatestProducts /> */}
        <Testimonials />

        <Collaboration />
        <Service />
      </div>
      <Footer />
    </>
  );
};
